import React, {useState, useEffect, useContext} from 'react';
import bs58 from 'bs58';
import styles from './ConnectWalletHeader.module.css';
import email_svg from '../static_files/connect-email.svg';
import okx_icon from '../static_files/OKX-icon.svg';
import coinbase_icon from '../static_files/Coinbase-icon.svg';
import walletconnect_icon from '../static_files/walletconnect-icon.svg';
import Phantom_icon from '../static_files/Phantom Wallet.svg';
import metamask_icon from '../static_files/MetaMask-icon.svg';
import okx_icon_mobile from '../static_files/OKX Wallet.png';
import coinbase_icon_mobile from '../static_files/Coinbase-icon.png';
import walletconnect_icon_mobile from '../static_files/walletconnect-icon.png';
import Phantom_icon_mobile from '../static_files/Phantom Wallet.png';
import metamask_icon_mobile from '../static_files/MetaMask-icon-fox.png';


import menu_icon from "../static_files/swap_main_menu_mobile_icon.svg";
import logo_svg from "../static_files/kiraAi logo.svg";
import rejectImg from '../static_files/rejectImg.svg';
import cancle_icon from '../static_files/cancel.svg';
import successImg from '../static_files/successImg.svg';
import warningImg from '../static_files/warningImg.svg';
import disconnectImg from '../static_files/disconnect.svg';
import emailLogoutImg from "../static_files/emailLogout.svg";
import menuDropDownImg from '../static_files/MenuDropDown.svg'
import {
    fetchBalancesAndNotifyParent,
    getTokenAccountFromWalletAddress,
    sleep2,
    sleep,
    fetchTokenBalances,
    chains,
    metadata,
    projectId, fetchThreeTokenBalancesWithoutProvider,
    // addMemoInstruction
} from './ConnectWalletHeaderOnchainHelper';
import {
    Connection,
    PublicKey,
    Transaction,
    TransactionInstruction,
    VersionedTransaction
} from '@solana/web3.js';
import {useLocation} from 'react-router-dom';

// Email login
import {useAuth} from '../../AuthContext';

// wallet connect
import {useWeb3Modal, createWeb3Modal, defaultSolanaConfig} from '@web3modal/solana/react';
import {solana} from '@web3modal/solana/chains';
// import {useWalletInfo} from '@web3modal/wagmi/react';
import {useWeb3ModalAccount} from '@web3modal/solana/react';
import {useWeb3ModalProvider} from '@web3modal/solana/react';


import {
    getOrCreateAssociatedTokenAccount,
    createTransferInstruction,
} from '@solana/spl-token';
import SideMenu from "./MobileMenu";
import {SwapMainAppContext} from "../../SwapMainAppContext";
import ConnectWalletHeaderAdminNavBar from "./ConnectWalletHeaderAdminNavBar";
import {LARGE_AMOUNT, USDI_API_URL} from "../../configs/config";
import {notifyAdminC2cRequest} from '../../utils/notifyAdminC2cRequest';
import {
    buildTimingFields,
    logTransactionTelemetry,
    waitForTransactionConfirmation,
} from '../../utils/transactionTelemetry';


/**
 * Props:
 *  - onWalletConnected : 用来传出 Component， 给parent 告诉连接的地址 + balance
 *  - amount: user input mint/redeem amount 输入金额
 *  - transactionTrigger: to trigger transaction by pressing the button 是否触发
 *  - toAddress: 默认是到squads vault 的账户
 *  - selectedToken: 传入 transaction用了什么token
 *  - selectedPaymentID: 用户cash redeem 的时候选择用什么PaymentMethod的ID
 *  - transactionType：传入 transaction redeem/mint?
 *  - transactionTime: 发生交易的时间
 *  - emailWallet: 从email address 传来的选择的wallet
 *  - onClearTransactions: 用来disconnect wallet时 清空transaction page state
 *  - onClearAccountData, // 接收从 Account.js 传进来的回调: 用来disconnect wallet时 清空 accounts page state
 *  - selectedChainTrigger: email 用户选择不同链的时候，头上的wallet address改变
 *  - isAdminHeader 用在admin page , BOOLEAN
 *  - transferComplete(); usdi transfer complete call back
 *   - c2cRedeemTransferComplete(); c2c transfer complete call back
 */
const APP_URL = "https://app.kira.trading/";
const WALLET_STANDARD_SOLANA_MAINNET = 'solana:mainnet';


// For wallet connect modal
createWeb3Modal({
    solanaConfig: defaultSolanaConfig({
        metadata,
        defaultChain: solana,
        enableInjected: true // Optional - defaults to true
    }), // required
    chains, // required
    projectId,
    enableAnalytics: true, // Optional - defaults to your Cloud configuration,
});

const getWalletStandardWallets = async () => {
    if (typeof window === 'undefined') return [];
    const wallets = new Set();
    const api = {
        register: (...walletsToRegister) => {
            walletsToRegister.filter(Boolean).forEach((wallet) => wallets.add(wallet));
        }
    };

    const handleRegister = (event) => {
        try {
            const callback = event?.detail;
            if (typeof callback === 'function') {
                callback(api);
            }
        } catch (error) {
            console.error('wallet-standard registration error:', error);
        }
    };

    window.addEventListener('wallet-standard:register-wallet', handleRegister);
    try {
        window.dispatchEvent(new CustomEvent('wallet-standard:app-ready', {detail: api}));
    } catch (error) {
        console.error('wallet-standard app-ready dispatch failed:', error);
    }
    await new Promise((resolve) => setTimeout(resolve, 0));
    window.removeEventListener('wallet-standard:register-wallet', handleRegister);

    return Array.from(wallets);
};

const findMetaMaskWalletStandard = async () => {
    const wallets = await getWalletStandardWallets();
    return wallets.find((wallet) => wallet?.name?.toLowerCase().includes('metamask'));
};

const getWalletStandardSolanaAccount = (wallet, accounts) => {
    const availableAccounts = accounts?.length ? accounts : wallet?.accounts || [];
    const mainnetAccount = availableAccounts.find((account) =>
        account?.chains?.includes(WALLET_STANDARD_SOLANA_MAINNET)
    );
    if (mainnetAccount) return mainnetAccount;
    return availableAccounts.find((account) =>
        account?.chains?.some((chain) => chain?.startsWith('solana:'))
    );
};

const getWalletStandardSolanaChain = (wallet, account) => {
    const walletChains = wallet?.chains || [];
    const accountChains = account?.chains || [];
    if (walletChains.includes(WALLET_STANDARD_SOLANA_MAINNET) &&
        accountChains.includes(WALLET_STANDARD_SOLANA_MAINNET)) {
        return WALLET_STANDARD_SOLANA_MAINNET;
    }
    const accountChain = accountChains.find((chain) => chain?.startsWith('solana:'));
    if (accountChain) return accountChain;
    const walletChain = walletChains.find((chain) => chain?.startsWith('solana:'));
    return walletChain || WALLET_STANDARD_SOLANA_MAINNET;
};

const serializeWalletStandardTransaction = (transaction) => {
    if (transaction instanceof VersionedTransaction) {
        return transaction.serialize();
    }
    return transaction.serialize({requireAllSignatures: false, verifySignatures: false});
};

const deserializeWalletStandardTransaction = (transactionBytes) => {
    try {
        return Transaction.from(transactionBytes);
    } catch (error) {
        return VersionedTransaction.deserialize(transactionBytes);
    }
};

// used to record transaction to db
async function record_transaction(payload) {
    try {
        const now = new Date();
        const month = String(now.getUTCMonth() + 1).padStart(2, "0");
        const day = String(now.getUTCDate()).padStart(2, "0");
        const year = now.getUTCFullYear();
        const hours = String(now.getUTCHours()).padStart(2, "0");
        const minutes = String(now.getUTCMinutes()).padStart(2, "0");
        const seconds = String(now.getUTCSeconds()).padStart(2, "0");
        const currentUTCTime = `${month}/${day}/${year}, ${hours}:${minutes}:${seconds}`;

        const finalPayload = {
            ...payload,
            txs_created_timestamp: currentUTCTime
        };
        const response = await fetch(
            "https://usdi-api-256611876551.europe-west1.run.app/record_transaction",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(finalPayload)
            }
        );

        if (!response.ok) {
            throw new Error(`Server error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error recording transaction:", error);
        throw error;
    }
}

const ConnectWalletHeader = ({
                                 amount,
                                 transactionTrigger,
                                 toAddress,
                                 onWalletConnected,
                                 selectedToken,
                                 transactionType,
                                 transactionTime,
                                 showPanel,
                                 setShowPanel,
                                 onKiraSent,
                                 onClearTransactions,
                                 onClearAccountData, // 接收从 Account.js 传进来的回调
                                 selectedPaymentId,
                                 selectedPaymentMethod,
                                 selectedChainTrigger,
                                 isKiraAITransaction = false, // 是否是KiraAI的交易
                                 isKiraAIPage = false,
                                 isAdminHeader = false,  // 新增可选参数，默认 false
                                 transferComplete,
                                 c2cRedeemTransferComplete,
                                 onWalletProviderReady,
                                 skipWalletDataFetch = false
                             }) => {
    const {
        notification, showNotification,
        set_recorded_txs_id,
        usdiTokenAddress,
        usdtTokenAddress,
        usdcTokenAddress,
        kraTokenAddress,
        c2csquadReceivingAddress
    } = useContext(SwapMainAppContext);
    const {
        walletAddress: connectedPublicKey,
        // rename setWalletAddress to setConnectedPublicKey locally
        //    connectedPublicKey =  完整的 address
        setWalletAddress: setConnectedPublicKey,
    } = useContext(SwapMainAppContext);
    // Track which wallet is connected
    const [connectedWalletType, setConnectedWalletType] = useState(null);
    // Shorten version address
    const [walletAddress, setWalletAddress] = useState(() => {
        const storedAddress = connectedPublicKey;
        return storedAddress ? shortenAddress(storedAddress) : 'Connect Wallet';
    });

    const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
    const [selectedMenuItem, setSelectedMenuItem] = useState('myAssets');


    const [okxSolanaProvider, setOkxSolanaProvider] = useState(null);
    const [coinbaseSolanaProvider, setCoinbaseSolanaProvider] = useState(null);
    const [phantomSolanaProvider, setPhantomSolanaProvider] = useState(null);
    const [metaMaskSolanaProvider, setMetaMaskSolanaProvider] = useState(null);

    // For wallet Connect
    const [walletConnectProvider, setWalletConnectProvider] = useState(null);
    const {open} = useWeb3Modal();
    const {address: modalAddress} = useWeb3ModalAccount();
    const {walletProvider} = useWeb3ModalProvider();

    // For detecting if the wallet extension has been installed
    const [isOkxDetected, setIsOkxDetected] = useState(false);
    const [isCoinbaseDetected, setIsCoinbaseDetected] = useState(false);
    const [isPhantomDetected, setIsPhantomDetected] = useState(false);
    const [isMetaMaskDetected, setIsMetaMaskDetected] = useState(false);

    //Gat way:
    const {logout, gatewayUserData} = useAuth();
    const location = useLocation();

    const notifyWalletProviderReady = (provider, publicKey, walletType) => {
        if (!onWalletProviderReady) return;
        onWalletProviderReady({provider, publicKey, walletType});
    };

    useEffect(() => {
        // 检查当前路由        TransactionErrorBox使用不同深色背景
        if (location.pathname === '/kira-ai') {
            document.documentElement.style.setProperty('--transactionErrorBox-background', 'rgb(50, 53, 61)');
        } else {
            document.documentElement.style.setProperty('--transactionErrorBox-background', '#1C1C1C');
        }
    }, [location]);

    // wallet Connect Use effect
    useEffect(() => {
        if (modalAddress) {
            setWalletAddress(shortenAddress(modalAddress));
            setConnectedPublicKey(modalAddress);
        }
    }, [modalAddress]);
    useEffect(() => {
        if (walletProvider) {
            if (connectedWalletType !== null) {
                handleWalletConnectSolana();
            }
        }
    }, [walletProvider]);

    // const RPC_URL = "https://rpc.ankr.com/solana/80465c767c6a5751c4cadf0778b6917d26c2d0a9ae583d3616ffaae71191a7c4";
    // const QUICKNODE_RPC_URL = "https://solitary-boldest-thunder.solana-mainnet.quiknode.pro/7e14722814e9fc29ad81532c2da66c2ffbe3781f";
    const RPC_URL = "https://mainnet.helius-rpc.com/?api-key=87eb0292-8ed2-4c97-94a3-2a325517875b"
    // 从email user 读取出来的address， 好像只是为了display用
    useEffect(() => {
        if ((localStorage.getItem("userEmail") && localStorage.getItem("emailUserWalletAddress") !== "null" && localStorage.getItem("emailUserWalletAddress") !== null && localStorage.getItem("emailUserWalletAddress") !== "requested")) {
            setWalletAddress(shortenAddress(localStorage.getItem("emailUserWalletAddress")));

        } else if (localStorage.getItem("userEmail") && gatewayUserData) {
            setWalletAddress("Create Wallet");
        }
    }, [gatewayUserData, selectedChainTrigger]);

    // -----------------------------------------
    // Use Effect for handling transactions
    // -----------------------------------------
    // Handel Transfer trigger ->
    // 1. cash redeem,
    // 2. amount > 11000 mint/redeem
    // 3. amount <= 11000
    // 4. kira
    // 5. only transfer USDI -> no additional action required, now it's only for admin user send usdi
    useEffect(() => {
        if (selectedToken === 'CASH') {
            const getC2CVaultAddress = async () => {
                try {
                    //找到用户应该先把USDi往那个squad合约发
                    const C2C_USDI_RECEIVING_TOKEN_ACCOUNT = await getTokenAccountFromWalletAddress(c2csquadReceivingAddress, usdiTokenAddress);
                    handleSolanaTransaction(C2C_USDI_RECEIVING_TOKEN_ACCOUNT);
                } catch (err) {
                    console.error('Error recording CASH transaction:', err);
                }
            };
            getC2CVaultAddress();
        } else if (selectedToken === 'KIRA' && Number(amount) > 0) {
            //  If the user wants to send KIRA tokens, use standard on-chain transfer. C2C
            const getC2CVaultAddress = async () => {
                try {
                    const C2C_KIRA_RECEIVING_TOKEN_ACCOUNT = await getTokenAccountFromWalletAddress(
                        c2csquadReceivingAddress,
                        kraTokenAddress
                    );
                    handleSolanaTransaction(C2C_KIRA_RECEIVING_TOKEN_ACCOUNT);
                } catch (err) {
                    console.error('Error transferring Kira :', err);
                    showNotification('error', `transferring Kira failed: ${err.message}`);
                }
            };
            getC2CVaultAddress();
        } else if (selectedToken === 'USDI' && Number(amount) > 0 && transactionType === "transfer") {
            //  admin user trying to send usdi to the backend wallet
            const transferUSDi = async () => {
                try {
                    handleSolanaTransaction();
                } catch (err) {
                    console.error('Error transferring USDi :', err);
                    showNotification('error', `transferring USDi failed: ${err.message}`);
                }
            };
            transferUSDi();

            // amount greater than 11000 use squad
        } else if (Number(amount) >= LARGE_AMOUNT) {
            handleSolanaTransaction();
            //Raydium swap
        } else if (Number(amount) > 0 && transactionTrigger) {
            async function doRaydiumSwap() {
                if (!connectedPublicKey) return;
                let providerToUse = null;
                if (connectedWalletType === 'okx') {
                    providerToUse = okxSolanaProvider;
                } else if (connectedWalletType === 'coinbase') {
                    providerToUse = coinbaseSolanaProvider;
                } else if (connectedWalletType === 'walletconnect') {
                    providerToUse = walletConnectProvider;
                } else if (connectedWalletType === 'phantom') {
                    providerToUse = phantomSolanaProvider;
                } else if (connectedWalletType === 'metamask') {
                    providerToUse = metaMaskSolanaProvider;
                }

                const {usdcBalance, usdtBalance, usdiBalance} = await fetchTokenBalances(
                    providerToUse,
                    connectedPublicKey,
                );
                if (!providerToUse || isNaN(amount) || Number(amount) <= 0) {
                    return;
                }
                const canProceed = verifyBalanceBeforeTransaction({
                    selectedToken,
                    transactionType,
                    amount,
                    usdcBalance,
                    usdtBalance,
                    usdiBalance,
                });
                if (!canProceed) {
                    showNotification('warning', "Insufficient wallet balance.");
                    if (window.createKiraAIMessage) {
                        window.createKiraAIMessage({
                            role: 'assistant',
                            content: `I noticed you have insufficient balance for this transaction. ${canProceed.message} Please add more funds to your wallet before proceeding.`
                        });
                    }
                    await fetchBalancesAndNotifyParent(providerToUse, connectedPublicKey, onWalletConnected);
                    return;
                }
                const jc = (await import('./raydiumSwap/jupiter-config.js')).default;
                jc.ownerAddress = new PublicKey(connectedPublicKey);
                // Set up signTransaction function for Jupiter (handles VersionedTransaction)
                jc.signTransaction = async (transaction) => {
                    // Jupiter uses VersionedTransaction
                    // Most modern wallet providers support VersionedTransaction directly
                    try {
                        const signed = await providerToUse.signTransaction(transaction);
                        return signed;
                    } catch (error) {
                        console.error('Error signing VersionedTransaction:', error);
                        // If signTransaction fails, try signAllTransactions (some providers use this)
                        if (providerToUse.signAllTransactions) {
                            const signedTxs = await providerToUse.signAllTransactions([transaction]);
                            return signedTxs[0];
                        }
                        throw error;
                    }
                };
                const {jupiterSwap} = await import('./raydiumSwap/jupiter-swap.js');
                try {
                    const result = await jupiterSwap({
                        transactionType,
                        tokenType: selectedToken,
                        amount: Number(amount)
                    });
                    const swapTelemetry = result.telemetry ?? {};

                    const logJupiterAttempt = async ({
                        transactionSignature,
                        confirmationResult,
                        errorMessage,
                    }) => {
                        await logTransactionTelemetry({
                            flow: 'jupiter_swap',
                            txs_type: transactionType,
                            method: selectedToken,
                            from_token_amount: amount,
                            from_address: connectedPublicKey,
                            transaction_signature: transactionSignature ?? null,
                            confirmation_result: confirmationResult,
                            error_message: errorMessage ?? null,
                            last_valid_block_height: swapTelemetry.lastValidBlockHeight ?? null,
                            block_height_at_send: swapTelemetry.blockHeightAtSend ?? null,
                            block_height_expired_at_send:
                                swapTelemetry.lastValidBlockHeight != null &&
                                swapTelemetry.blockHeightAtSend != null &&
                                swapTelemetry.blockHeightAtSend > swapTelemetry.lastValidBlockHeight,
                            ...buildTimingFields(swapTelemetry),
                        });
                    };

                    if (result.success) {
                        const txId = result.txId;
                        const explorerLink = `https://solscan.io/tx/${txId}`;

                        showNotification(
                            'warning',
                            `In progress: ${transactionType} of ${amount} ${selectedToken.toUpperCase()} submitted. Confirming on-chain…
                         <a href="${explorerLink}" target="_blank" rel="noreferrer">Check on Explorer</a>`,
                            90000
                        );
                        if (isKiraAITransaction && window.createKiraAIMessage) {
                            window.createKiraAIMessage({
                                id: Date.now(),
                                text: `Transaction submitted. Awaiting on-chain confirmation… [View Transaction](${explorerLink})`,
                                sender: 'assistant',
                                timestamp: new Date().toISOString(),
                            });
                        }

                        try {
                            const connection = new Connection(RPC_URL, "confirmed");
                            const {confirmationResult} = await waitForTransactionConfirmation(connection, txId, {
                                lastValidBlockHeight: result.lastValidBlockHeight,
                            });

                            await logJupiterAttempt({
                                transactionSignature: txId,
                                confirmationResult,
                            });

                            console.log(`Swapped via Jupiter API: https://solscan.io/tx/${txId}`)
                            showNotification('success', `${transactionType} of ${amount} ${selectedToken.toUpperCase()} completed successfully!
                         <a href="${explorerLink}" target="_blank" rel="noreferrer">Check on Explorer</a>`);
                            if (isKiraAITransaction && window.createKiraAIMessage) {
                                window.createKiraAIMessage({
                                    id: Date.now(),
                                    text: `Great! Your ${transactionType} transaction of ${amount} usdi with ${selectedToken} was completed! You can view its status on Solscan: [View Transaction](${explorerLink})`,
                                    sender: 'assistant',
                                    timestamp: new Date().toISOString(),
                                });
                            }

                            const referralCode = localStorage.getItem('referralCode') || '';
                            const payload = {
                                txs_type: transactionType,
                                method: selectedToken,
                                from_token_amount: amount,
                                from_address: connectedPublicKey,
                                transaction_signature: txId,
                                referral_code: referralCode
                            };
                            await record_transaction(payload);
                            await new Promise(resolve => setTimeout(resolve, 3000));
                            await fetchBalancesAndNotifyParent(providerToUse, connectedPublicKey, onWalletConnected);
                        } catch (err) {
                            console.error('Swap transaction failed:', err)

                            await logJupiterAttempt({
                                transactionSignature: txId,
                                confirmationResult: err.confirmationResult ?? 'error',
                                errorMessage: err.message,
                            });

                            // Persist failed attempt for ops; user portal will hide status=failed.
                            try {
                                const referralCode = localStorage.getItem('referralCode') || '';
                                await record_transaction({
                                    txs_type: transactionType,
                                    method: selectedToken,
                                    from_token_amount: amount,
                                    from_address: connectedPublicKey,
                                    transaction_signature: txId,
                                    referral_code: referralCode,
                                    status: 'failed',
                                });
                            } catch (recordErr) {
                                console.warn('Failed to record dropped/failed swap:', recordErr);
                            }

                            showNotification('error', `Failed: ${transactionType} of ${amount} ${selectedToken.toUpperCase()} did not confirm on-chain.
                         <a href="${explorerLink}" target="_blank" rel="noreferrer">Check on Explorer</a>`);
                            if (isKiraAITransaction && window.createKiraAIMessage) {
                                window.createKiraAIMessage({
                                    id: Date.now(),
                                    text: `Your ${transactionType} could not be confirmed on-chain: ${err.message}. Please retry. [View Transaction](${explorerLink})`,
                                    sender: 'assistant',
                                    timestamp: new Date().toISOString(),
                                });
                            }
                        }


                    } else {
                        console.error('Raydium swap error:', result.code, result.message);
                        await logJupiterAttempt({
                            transactionSignature: null,
                            confirmationResult: result.code === 4001 ? 'user_rejected' : 'send_failed',
                            errorMessage: result.message,
                        });
                        // Trigger KiraAI message if the transaction is from KiraAI
                        console.log("isKiraAITransaction", isKiraAITransaction)
                        console.log("window.createKiraAIMessage", window.createKiraAIMessage)
                        if (result.code === 4001) {
                            showNotification('error', "User rejected the transaction.");
                            if (isKiraAITransaction && window.createKiraAIMessage) {
                                console.log("Trigger KiraAI message if the transaction is from KiraAI")
                                window.createKiraAIMessage({
                                    id: Date.now(),
                                    text: "I noticed you rejected the transaction. If you have any concerns or questions, feel free to ask me about them.",
                                    sender: 'assistant',
                                    timestamp: new Date().toISOString(),
                                });
                            }
                        } else {
                            showNotification('error', `Transaction failed: ${result.message}`);
                            if (isKiraAITransaction && window.createKiraAIMessage) {
                                window.createKiraAIMessage({
                                    id: Date.now(),
                                    text: `I encountered an error while processing your transaction: ${result.message}. Would you like me to help you retry the transaction?`,
                                    sender: 'assistant',
                                    timestamp: new Date().toISOString(),
                                });
                            }
                        }
                    }
                } catch (err) {
                    console.error(`Error transferring token on Solana:`, err);
                    if (err?.code === 4001) {
                        showNotification('error', "User rejected the transaction.");
                        if (isKiraAITransaction && window.createKiraAIMessage) {
                            window.createKiraAIMessage({
                                id: Date.now(),
                                text: "The transaction was cancelled. Is there anything you'd like me to clarify about the process?",
                                sender: 'assistant',
                                timestamp: new Date().toISOString(),
                            });
                        }
                    } else {
                        showNotification('error', `Transaction failed: ${err.message}`);
                        console.log("Transaction failed: ", err.message);
                        if (isKiraAITransaction && window.createKiraAIMessage) {
                            window.createKiraAIMessage({
                                id: Date.now(),
                                text: `There was an error with your transaction: ${err.message}. Would you like me to help you troubleshoot this issue?`,
                                sender: 'assistant',
                                timestamp: new Date().toISOString(),
                            });
                        }
                    }
                }
            }

            doRaydiumSwap();
        }
    }, [transactionTrigger]);

    // 检测  Wallet extension ：是否存在
    useEffect(() => {
        if (window.okxwallet && window.okxwallet.solana) {
            setIsOkxDetected(true);
        }
        if (window.coinbaseSolana) {
            setIsCoinbaseDetected(true);
        }
        let phantomProvider = window.phantom?.solana || window.solana;
        if (phantomProvider && phantomProvider.isPhantom) {
            setIsPhantomDetected(true);
        }
        if (window.ethereum && window.ethereum.isMetaMask) {
            setIsMetaMaskDetected(true);
        } else {
            getWalletStandardWallets()
                .then((wallets) => {
                    if (wallets.some((wallet) => wallet?.name?.toLowerCase().includes('metamask'))) {
                        setIsMetaMaskDetected(true);
                    }
                })
                .catch((error) => {
                    console.warn('wallet-standard detection failed:', error);
                });
        }
    }, []);


    // Read local storage for last connected wallet
    useEffect(() => {
        const lastWallet = localStorage.getItem('lastConnectedWallet');
        const isEmailLogin = localStorage.getItem('emailUserWalletAddress');
        if (isEmailLogin) {
            // (No action needed: email is already connected)
            fetchThreeTokenBalancesWithoutProvider(isEmailLogin, onWalletConnected);

        } else if (lastWallet === 'okx') {
            handleOKXWalletSolana();
        } else if (lastWallet === 'coinbase') {
            handleCoinbaseWalletSolana();
        } else if (lastWallet === 'phantom') {
            handlePhantomWalletSolana();
        } else if (lastWallet === 'walletconnect') {
            handleWalletConnectSolana();
        } else if (lastWallet === 'metamask') {
            handleMetaMaskSolana();
        }
    }, []);

    // set user's vip class
    const fetchUSDiHolderData = async (wa) => {
        try {
            const response = await fetch(`${USDI_API_URL}/usdi_holders_info_table_solana?address=${wa}`);
            if (!response.ok) throw new Error('Network response was not ok');
            const result = await response.json();
            if (result[0]) {
                localStorage.setItem('userClass', result[0].user_class);
            }
        } catch (error) {
            console.error("Error fetching data!:", error);
        }
    };

    // -----------------------------------------
    // UTILITY
    // -----------------------------------------
    const handleConnectWalletClick = (e) => {
        e.stopPropagation();
        setShowPanel((prev) => !prev);
    };
    const closePanel = () => setShowPanel(false);
    const stopPropagation = (e) => e.stopPropagation();
    const handleOutsideClick = () => {
        if (showPanel) closePanel();
    };
    const handleMenuIconClick = (e) => {
        e.stopPropagation();
        setIsSideMenuOpen(true);
    };
    const handleOutsideClickSideMenu = () => {
        setIsSideMenuOpen(false);
    };
    const handleMenuItemClick = (item) => {
        setSelectedMenuItem(item);
        setIsSideMenuOpen(false);
    };
    const handleLoginWithEmail = () => {
        window.location.href = 'https://gateway.kira.trading/';

    };

    const handleLogoutWithEmail = () => {

        if (logout()) {
            showNotification('success', "You have successfully logged out of your email account.");

        } else {
            showNotification('error', "An error occurred while logging out of your email account. Please try again.");
        }
        setWalletAddress("Connect Wallet")
    };

    function shortenAddress(address, startLength = 4, endLength = 4) {
        if (!address) return '';
        if (address.length <= startLength + endLength) {
            return address;
        }
        const start = address.slice(0, startLength);
        const end = address.slice(-endLength);
        return `${start}..${end}`;
    }

    function isMobile() {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }

    const createWalletStandardSolanaProvider = (wallet, account, chain) => {
        const signTransactionFeature = wallet?.features?.['solana:signTransaction'];
        const signAndSendFeature = wallet?.features?.['solana:signAndSendTransaction'];
        const signMessageFeature = wallet?.features?.['solana:signMessage'];
        const accountPublicKey = account?.publicKey || (account?.address ? bs58.decode(account.address) : null);

        return {
            publicKey: accountPublicKey ? new PublicKey(accountPublicKey) : null,
            signTransaction: async (transaction) => {
                if (!signTransactionFeature?.signTransaction) {
                    throw new Error('MetaMask does not support solana:signTransaction.');
                }
                const [output] = await signTransactionFeature.signTransaction({
                    account,
                    transaction: serializeWalletStandardTransaction(transaction),
                    chain
                });
                return deserializeWalletStandardTransaction(output.signedTransaction);
            },
            signAndSendTransaction: async (transaction) => {
                const serialized = serializeWalletStandardTransaction(transaction);
                if (signAndSendFeature?.signAndSendTransaction) {
                    const [output] = await signAndSendFeature.signAndSendTransaction({
                        account,
                        transaction: serialized,
                        chain
                    });
                    return {signature: bs58.encode(output.signature)};
                }
                if (!signTransactionFeature?.signTransaction) {
                    throw new Error('MetaMask does not support solana:signAndSendTransaction.');
                }
                const [output] = await signTransactionFeature.signTransaction({
                    account,
                    transaction: serialized,
                    chain
                });
                const signedTransaction = deserializeWalletStandardTransaction(output.signedTransaction);
                const connection = new Connection(RPC_URL, 'confirmed');
                const signature = await connection.sendRawTransaction(signedTransaction.serialize());
                return {signature};
            },
            signMessage: async (message) => {
                if (!signMessageFeature?.signMessage) {
                    throw new Error('MetaMask does not support solana:signMessage.');
                }
                const [output] = await signMessageFeature.signMessage({account, message});
                return {signature: output.signature};
            },
            disconnect: async () => {}
        };
    };

    // -----------------------------------------
    // OKX CONNECT & FETCH
    // -----------------------------------------
    const handleOKXWalletSolana = async () => {
        // Email 登录过了不能再connect 钱包
        if (localStorage.getItem("userEmail")) {
            setShowPanel(false);
            showNotification('warning', "Please log out of your email account first, then reconnect your wallet.");
            return;
        }
        try {
            const provider = window.okxwallet?.solana;
            if (!provider) {
                if (isMobile()) {
                    const encodedDappUrl = encodeURIComponent(APP_URL);
                    const deepLink = "okx://wallet/dapp/url?dappUrl=" + encodedDappUrl;

                    const storeUrl = "https://www.okx.com/download";
                    const start = Date.now();
                    setTimeout(() => {
                        const elapsed = Date.now() - start;
                        if (elapsed < 1500) {
                            window.location.href = storeUrl;
                        }
                    }, 1500);
                    window.location.href = "https://www.okx.com/download?deeplink=" + encodeURIComponent(deepLink);
                    return;
                } else {
                    window.open('https://web3.okx.com/zh-hans/download', '_blank');
                    return
                }
            }
            await provider.connect();
            const publicKey = provider.publicKey?.toString();
            if (!publicKey) {
                showNotification('error', 'Unable to retrieve Solana public key from OKX Wallet.');
                return;
            }
            setConnectedWalletType("okx");
            localStorage.setItem('lastConnectedWallet', 'okx');
            setWalletAddress(shortenAddress(publicKey));

            localStorage.setItem('walletAddress', publicKey);
            setConnectedPublicKey(publicKey);
            setOkxSolanaProvider(provider);
            setShowPanel(false);
            notifyWalletProviderReady(provider, publicKey, "okx");
            if (!skipWalletDataFetch) {
                fetchUSDiHolderData(publicKey);
                await fetchBalancesAndNotifyParent(provider, publicKey, onWalletConnected);
            }

        } catch (error) {
            console.error('Error connecting to OKX Wallet (Solana):', error);
        }
    };

    // -----------------------------------------
    // COINBASE CONNECT & FETCH
    // -----------------------------------------
    const handleCoinbaseWalletSolana = async () => {
        // Email 登录过了不能再connect 钱包
        if (localStorage.getItem("userEmail")) {
            setShowPanel(false);
            showNotification('warning', "Please log out of your email account first, then reconnect your wallet.");
            return;
        }
        try {
            const provider = window.coinbaseSolana;
            if (!provider) {
                if (isMobile()) {
                    const ua = navigator.userAgent;
                    const isIOS = /iPhone|iPad|iPod/i.test(ua);

                    let coinbaseLink = "";
                    if (isIOS) {
                        coinbaseLink = `cbwallet://dapp?url=${encodeURIComponent(APP_URL)}`;
                    } else {
                        coinbaseLink = `https://go.cb-w.com/dapp?cb_url=${encodeURIComponent(APP_URL)}`;
                    }

                    const storeUrl = "https://www.coinbase.com/en-ca/wallet/downloads";
                    const start = Date.now();
                    setTimeout(() => {
                        const elapsed = Date.now() - start;
                        if (elapsed < 1500) {
                            window.location.href = storeUrl;
                        }
                    }, 1500);

                    window.location.href = coinbaseLink;
                    return;
                } else {
                    window.open('https://www.coinbase.com/wallet', '_blank');
                    return;
                }

            }
            await provider.connect();
            const publicKey = provider.publicKey?.toString();
            if (!publicKey) {
                showNotification('error', 'Unable to retrieve Solana public key from Coinbase Wallet.');
                return;
            }
            setConnectedWalletType("coinbase");
            localStorage.setItem('lastConnectedWallet', 'coinbase');
            setWalletAddress(shortenAddress(publicKey));

            localStorage.setItem('walletAddress', publicKey);

            setConnectedPublicKey(publicKey);
            setCoinbaseSolanaProvider(provider);
            setShowPanel(false);
            notifyWalletProviderReady(provider, publicKey, "coinbase");
            if (!skipWalletDataFetch) {
                fetchUSDiHolderData(publicKey);
                await fetchBalancesAndNotifyParent(provider, publicKey, onWalletConnected);
            }
        } catch (error) {
            console.error('Error connecting to Coinbase Wallet (Solana):', error);
        }
    };

    // -----------------------------------------
    // WALLETCONNECT CONNECT & FETCH
    // -----------------------------------------
    const handleWalletConnectSolana = async () => {
        // Email 登录过了不能再connect 钱包
        if (localStorage.getItem("userEmail")) {
            setShowPanel(false);
            showNotification('warning', "Please log out of your email account first, then reconnect your wallet.");
            return;
        }
        try {
            setShowPanel(false);
            await open({view: 'Connect'}); // Opens the WalletConnect modal
            await new Promise(resolve => setTimeout(resolve, 1000));
            if (modalAddress) {
                setConnectedWalletType("walletconnect");
                localStorage.setItem('lastConnectedWallet', 'walletconnect');
                localStorage.setItem('walletAddress', modalAddress);

                setWalletAddress(shortenAddress(modalAddress));

                setConnectedPublicKey(modalAddress);
                setWalletConnectProvider(walletProvider);
                if (walletProvider) {
                    notifyWalletProviderReady(walletProvider, modalAddress, "walletconnect");
                }
                if (!skipWalletDataFetch) {
                    fetchUSDiHolderData(modalAddress);
                    if (walletProvider) {
                        await fetchBalancesAndNotifyParent(walletProvider, modalAddress, onWalletConnected);
                    }
                }
                setShowPanel(false);
            } else {
                showNotification('warning', 'WalletConnect connection failed: Please try again.');
            }
        } catch (error) {
            console.error('WalletConnect error:', error);
        }
    };

    const getPhantomProvider = () => {
        let provider = window.phantom?.solana;
        if (!provider) {
            provider = window.solana;
        }
        if (provider && provider.isPhantom) {
            return provider;
        }
        // window.open('https://phantom.app/', '_blank');
        return null;
    };
    const handlePhantomWalletSolana = async () => {
        // Email 登录过了不能再connect 钱包
        if (localStorage.getItem("userEmail")) {
            setShowPanel(false);
            showNotification('warning', "Please log out of your email account first, then reconnect your wallet.");
            return;
        }

        try {
            const provider = getPhantomProvider();
            if (!provider) {
                if (isMobile()) {
                    const storeUrl = "https://phantom.com/download";


                    const phantomLink = `https://phantom.app/ul/browse/${encodeURIComponent(APP_URL)}?ref=${encodeURIComponent(APP_URL)}`;

                    // 1.5 秒后若仍停留在当前页面 => Phantom 未安装 => 跳转下载
                    const start = Date.now();
                    setTimeout(() => {
                        const elapsed = Date.now() - start;
                        if (elapsed < 2500) {
                            window.location.href = storeUrl;
                        }
                    }, 2500);
                    window.location.href = phantomLink;

                    // 立即尝试跳转 deeplink
                    return;
                } else {
                    window.open('https://phantom.com/', '_blank');
                    return;
                }
            }
            // Request connection to the Phantom Wallet
            await provider.connect();
            const publicKey = provider.publicKey?.toString();
            if (!publicKey) {
                showNotification('error', 'Unable to retrieve Solana public key from Phantom Wallet.');
                return;
            }
            // Update state with Phantom connection details
            setConnectedWalletType("phantom");
            localStorage.setItem('lastConnectedWallet', 'phantom');
            setWalletAddress(shortenAddress(publicKey));
            localStorage.setItem('walletAddress', publicKey);
            setConnectedPublicKey(publicKey);
            setPhantomSolanaProvider(provider);
            setShowPanel(false);
            notifyWalletProviderReady(provider, publicKey, "phantom");
            if (!skipWalletDataFetch) {
                fetchUSDiHolderData(publicKey);
                await fetchBalancesAndNotifyParent(provider, publicKey, onWalletConnected);
            }
        } catch (error) {
            console.error('Error connecting to Phantom Wallet (Solana):', error);
        }
    };

    const handleMetaMaskSolana = async () => {
        // Email 登录过了不能再connect 钱包
        if (localStorage.getItem("userEmail")) {
            setShowPanel(false);
            showNotification('warning', "Please log out of your email account first, then reconnect your wallet.");
            return;
        }
        try {
            const wallet = await findMetaMaskWalletStandard();
            if (!wallet) {
                if (isMobile()) {
                    const metamaskLink = `https://metamask.app.link/dapp/${window.location.href}`;
                    window.location.href = metamaskLink;
                } else {
                    window.open('https://metamask.io/download/', '_blank');
                }
                return;
            }

            const connectFeature = wallet.features?.['standard:connect'];
            if (!connectFeature?.connect) {
                showNotification('error', 'MetaMask does not expose Wallet Standard connect.');
                return;
            }

            let connectResult;
            try {
                connectResult = await connectFeature.connect();
            } catch (error) {
                if (error?.code === 4001) {
                    showNotification('error', 'User rejected the request.');
                    return;
                }
                throw error;
            }

            const account = getWalletStandardSolanaAccount(wallet, connectResult?.accounts);
            if (!account) {
                showNotification('error', 'No Solana account found. Please enable Solana in MetaMask.');
                return;
            }

            const chain = getWalletStandardSolanaChain(wallet, account);
            const publicKey = account.address || (account.publicKey ? bs58.encode(account.publicKey) : null);
            if (!publicKey) {
                showNotification('error', 'Unable to retrieve Solana public key from MetaMask.');
                return;
            }
            const provider = createWalletStandardSolanaProvider(wallet, account, chain);

            setConnectedWalletType("metamask");
            localStorage.setItem('lastConnectedWallet', 'metamask');
            setWalletAddress(shortenAddress(publicKey));

            localStorage.setItem('walletAddress', publicKey);
            setConnectedPublicKey(publicKey);
            setMetaMaskSolanaProvider(provider);
            setShowPanel(false);
            notifyWalletProviderReady(provider, publicKey, "metamask");
            if (!skipWalletDataFetch) {
                fetchUSDiHolderData(publicKey);
                await fetchBalancesAndNotifyParent(provider, publicKey, onWalletConnected);
            }
        } catch (error) {
            console.error('Error connecting to MetaMask Solana:', error);
            showNotification('error', 'Failed to connect to MetaMask for Solana.');
        }
    };

    function verifyBalanceBeforeTransaction({
                                                selectedToken,
                                                transactionType,
                                                amount,
                                                usdcBalance,
                                                usdtBalance,
                                                usdiBalance,
                                                kiraBalance
                                            }) {
        const needed = Number(amount) || 0;
        if (transactionType === 'mint') {
            if (selectedToken === 'USDC' && needed > usdcBalance) {
                return false;
            }
            if (selectedToken === 'USDT' && needed > usdtBalance) {
                return false;
            }
        } else if (selectedToken === "KIRA") {
            if (needed > kiraBalance) {
                return false;
            }
        } else if (transactionType === 'redeem') {
            if (needed > usdiBalance) {
                return false;
            }
        } else if (transactionType === "transfer") {
            if (needed > usdiBalance) {
                return false;
            }
        }
        return true;
    }

    // -----------------------------------------
    // TRANSFER LOGIC
    // -----------------------------------------
    const handleSolanaTransaction = async (C2C_RECEIVING_TOKEN_ACCOUNT = null) => {
        if (!connectedPublicKey) {
            return;
        }
        let providerToUse = null;
        if (connectedWalletType === 'okx') {
            providerToUse = okxSolanaProvider;
        } else if (connectedWalletType === 'coinbase') {
            providerToUse = coinbaseSolanaProvider;
        } else if (connectedWalletType === 'phantom') {
            providerToUse = phantomSolanaProvider;
        } else if (connectedWalletType === 'walletconnect') {
            providerToUse = walletConnectProvider;
        } else if (connectedWalletType === 'metamask') {
            providerToUse = metaMaskSolanaProvider;
        }
        const {
            usdcBalance,
            usdtBalance,
            usdiBalance,
            kiraBalance
        } = await fetchTokenBalances(providerToUse, connectedPublicKey);
        if (!providerToUse || isNaN(amount) || Number(amount) <= 0) {
            // trigger kiraAI chat message about insufficient balance
            if (window.createKiraAIMessage) {
                window.createKiraAIMessage({
                    role: 'assistant',
                    content: `I noticed you have insufficient balance for this transaction. Please add more funds to your wallet before proceeding.`
                });
            }
            return;
        }

        const verificationResult = verifyBalanceBeforeTransaction({
            selectedToken,
            transactionType,
            amount,
            usdcBalance,
            usdtBalance,
            usdiBalance,
            kiraBalance
        });
        if (!verificationResult) {
            showNotification('warning', `Insufficient ${selectedToken} Balance`);
            // Trigger KiraAI chat message about insufficient balance
            if (window.createKiraAIMessage) {
                window.createKiraAIMessage({
                    role: 'assistant',
                    content: `I noticed you have insufficient balance for this transaction. ${verificationResult.message} Please add more funds to your wallet before proceeding.`
                });
            }
            await fetchBalancesAndNotifyParent(providerToUse, connectedPublicKey, onWalletConnected);
            return;
        }
        if (selectedToken === 'CASH') {
            await transferSplToken(connectedPublicKey, providerToUse, 'USDI', C2C_RECEIVING_TOKEN_ACCOUNT);
        } else if (selectedToken === 'KIRA') {
            await transferSplToken(connectedPublicKey, providerToUse, 'KIRA', C2C_RECEIVING_TOKEN_ACCOUNT);
        } else if (transactionType === 'mint') {
            await transferSplToken(connectedPublicKey, providerToUse, selectedToken, null);
        } else if (transactionType === 'redeem') {
            await transferSplToken(connectedPublicKey, providerToUse, 'USDI', null);
        } else if (transactionType === 'transfer') {
            await transferSplToken(connectedPublicKey, providerToUse, 'USDI', null);
        } else {
            console.log(`Transaction type "${transactionType}" not implemented.`);
        }
        if (isKiraAITransaction && window.createKiraAIMessage) {
            window.createKiraAIMessage({
                id: Date.now(),
                text: `Great! Your ${transactionType} transaction of ${amount} usdi with ${selectedToken} was completed! The admins will confirm the transaction shortly.`,
                sender: 'assistant',
                timestamp: new Date().toISOString(),
            });
        }
    };

    const transferSplToken = async (fromPublicKeyStr, provider, tokenType, C2C_RECEIVING_TOKEN_ACCOUNT) => {
        try {
            const connection = new Connection(RPC_URL, "confirmed");
            const fromPublicKey = new PublicKey(fromPublicKeyStr);
            let tokenMintAddress;
            let toTokenAccountPubkey;
            let readableToken;
            // 有C2C_RECEIVING_TOKEN_ACCOUNT -> cash redeem, 转账给squad c2c account
            if (C2C_RECEIVING_TOKEN_ACCOUNT !== null && tokenType === "USDI") {
                tokenMintAddress = usdiTokenAddress;
                readableToken = "USDi";
                toTokenAccountPubkey = new PublicKey(C2C_RECEIVING_TOKEN_ACCOUNT);
                // 有C2C_RECEIVING_TOKEN_ACCOUNT -> cash redeem, node operator 转KIRA给squad c2c account
            } else if (C2C_RECEIVING_TOKEN_ACCOUNT !== null && tokenType === "KIRA") {
                tokenMintAddress = kraTokenAddress;
                readableToken = "Kira";
                toTokenAccountPubkey = new PublicKey(C2C_RECEIVING_TOKEN_ACCOUNT);
            } else if (tokenType === 'USDT') {
                tokenMintAddress = usdtTokenAddress;
                readableToken = "USDT";
                const toTokenAddress = await getTokenAccountFromWalletAddress(toAddress, usdtTokenAddress)
                toTokenAccountPubkey = new PublicKey(toTokenAddress);
            } else if (tokenType === 'USDC') {
                tokenMintAddress = usdcTokenAddress;
                readableToken = "USDC";
                const toTokenAddress = await getTokenAccountFromWalletAddress(toAddress, usdcTokenAddress)
                toTokenAccountPubkey = new PublicKey(toTokenAddress);
            } else if (tokenType === 'USDI') {
                tokenMintAddress = usdiTokenAddress;
                readableToken = "USDi";
                // 管理员用户 分发USDI interest 先给后台钱包发钱的时候
                if (transactionType === "transfer") {
                    const toTokenAddress = await getTokenAccountFromWalletAddress(toAddress, usdiTokenAddress)
                    toTokenAccountPubkey = new PublicKey(toTokenAddress)
                } else {
                    const toTokenAddress = await getTokenAccountFromWalletAddress(toAddress, usdiTokenAddress)
                    toTokenAccountPubkey = new PublicKey(toTokenAddress);
                }
            } else {
                showNotification('error', "Unknown token type. Canceling transaction.");
                return;
            }

            const latestBlockhash = await connection.getLatestBlockhash("confirmed");
            const quoteTimestamp = Date.now();
            let signature;

            // prepare a signer object
            const payer = {
                publicKey: fromPublicKey,
                signTransaction: async (transaction) => {
                    return await provider.signTransaction(transaction);
                },
            };

            const mintPubkey = new PublicKey(tokenMintAddress);
            const fromTokenAccount = await getOrCreateAssociatedTokenAccount(
                connection,
                payer,
                mintPubkey,
                fromPublicKey
            );
            const amountInBaseUnits = Math.floor(Number(amount) * 1_000_000);
            if (isNaN(amountInBaseUnits) || amountInBaseUnits <= 0) {
                showNotification('error', `Invalid ${readableToken} amount. Please provide a positive number.`);
                return;
            }
            // Create the transfer instruction
            const transferIx = createTransferInstruction(
                fromTokenAccount.address,
                toTokenAccountPubkey,
                fromPublicKey,
                amountInBaseUnits
            );

            // --- ADDED MEMO INSTRUCTION --- 这一段不要随意改动， 因为在后台raw blockchain transaction 有parsed data
            const memoText = `Send ${amount} ${readableToken} to ${toTokenAccountPubkey.toBase58()}`;
            const memoIx = new TransactionInstruction({
                keys: [],
                programId: new PublicKey('MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr'),
                data: Buffer.from(memoText, 'utf8'),
            });

            // Build the transaction with transfer + memo
            const transaction = new Transaction().add(transferIx).add(memoIx);
            transaction.feePayer = fromPublicKey;
            transaction.recentBlockhash = latestBlockhash.blockhash;

            const blockHeightAtSend = await connection.getBlockHeight('confirmed');
            const result = await provider.signAndSendTransaction(transaction);
            signature = result.signature;
            const sendTimestamp = Date.now();
            const signTimestamp = sendTimestamp;
            console.log("signature", signature);

            const splTelemetry = {
                quoteTimestamp,
                signTimestamp,
                sendTimestamp,
                lastValidBlockHeight: latestBlockhash.lastValidBlockHeight,
                blockHeightAtSend,
            };

            const logSplAttempt = async ({confirmationResult, errorMessage}) => {
                await logTransactionTelemetry({
                    flow: 'spl_transfer',
                    txs_type: transactionType,
                    method: selectedToken,
                    from_token_amount: amount,
                    from_address: fromPublicKeyStr,
                    transaction_signature: signature ?? null,
                    confirmation_result: confirmationResult,
                    error_message: errorMessage ?? null,
                    last_valid_block_height: splTelemetry.lastValidBlockHeight,
                    block_height_at_send: splTelemetry.blockHeightAtSend,
                    block_height_expired_at_send:
                        splTelemetry.blockHeightAtSend > splTelemetry.lastValidBlockHeight,
                    ...buildTimingFields(splTelemetry),
                });
            };

            let confirmationResult = 'confirmed';
            try {
                ({confirmationResult} = await waitForTransactionConfirmation(connection, signature, {
                    lastValidBlockHeight: latestBlockhash.lastValidBlockHeight,
                }));
            } catch (confirmErr) {
                confirmationResult = confirmErr.confirmationResult ?? 'error';
                await logSplAttempt({
                    confirmationResult,
                    errorMessage: confirmErr.message,
                });
                throw confirmErr;
            }

            await logSplAttempt({confirmationResult});

            const explorerLink = `https://solscan.io/tx/${signature}`;
            showNotification('success', `${transactionType} of ${amount} ${readableToken} successfully submitted.
                 <a href="${explorerLink}" target="_blank" rel="noreferrer">Check on Explorer</a>`);

            // 等三秒在刷新balance
            await new Promise(resolve => setTimeout(resolve, 3000));
            await fetchBalancesAndNotifyParent(provider, fromPublicKeyStr, onWalletConnected);
            if (transactionType === "transfer") {
                transferComplete();

                // 有C2C_RECEIVING_TOKEN_ACCOUNT -> cash redeem
            } else if (C2C_RECEIVING_TOKEN_ACCOUNT !== null && tokenType === "USDI") {
                try {
                    const response = await fetch("https://usdi-api-256611876551.europe-west1.run.app/cash_redeem/record_cash", {
                        method: "POST",
                        headers: {"Content-Type": "application/json"},
                        body: JSON.stringify({
                            requester_wallet_address: fromPublicKeyStr,
                            redeem_amount: amount,
                            utc_time: transactionTime,
                            transfer_signature: signature,
                            payment_info_id: selectedPaymentId,
                            payment_info_eta: selectedPaymentMethod ? selectedPaymentMethod.processing_time : null,
                            payment_info_fees: selectedPaymentMethod ? selectedPaymentMethod.fees : null
                        })
                    });
                    const data = await response.json();
                    // console.log("response data", data); // { txs_id: 505 }

                    // Now call your callback with the txs_id
                    c2cRedeemTransferComplete(data.txs_id);
                    if (!response.ok) {
                        throw new Error(`Server responded with status ${response.status}`);
                    }
                    notifyAdminC2cRequest({
                        source: 'wallet_record_cash',
                        wallet_address: fromPublicKeyStr,
                        amount_usdi: amount,
                        transfer_signature: signature,
                        txs_id: data.txs_id ?? null,
                        payment_info_id: selectedPaymentId ?? null,
                        payment_method: selectedPaymentMethod?.payment_method ?? null,
                    });
                    // record cash 之后设置选择的payment method 设置为默认支付方式
                    await fetch("https://max1-funding-arb.uc.r.appspot.com/set_default_payment", {
                        method: "POST",
                        headers: {"Content-Type": "application/json"},
                        body: JSON.stringify({
                            wallet_address: connectedPublicKey,
                            payment_info_id: selectedPaymentId,
                        })
                    });
                    showNotification('success', `Cash received of ${amount} ${selectedToken.toUpperCase()} .
                         <a href="${explorerLink}" target="_blank" rel="noreferrer">Check on Explorer</a>`);
                } catch (error) {
                    console.error("Cash or redeem error:", error);
                    showNotification('error', `Error: ${error.message}`);
                }
            } else if (C2C_RECEIVING_TOKEN_ACCOUNT !== null && tokenType === "KIRA") {
                if (onKiraSent) {
                    onKiraSent({
                        from: connectedPublicKey,
                        amount,
                        signature
                    });
                }
            } else if (transactionType === 'mint') {
                const referralCode = localStorage.getItem('referralCode') || '';

                const payload = {
                    txs_type: transactionType,
                    method: selectedToken,
                    from_token_amount: amount,
                    from_address: connectedPublicKey,
                    transaction_signature: signature,
                    referral_code: referralCode

                };
                const data = await record_transaction(payload);
                try {
                    const txsId = data?.txs_id ?? data?.id ?? null;
                    if (txsId !== null && set_recorded_txs_id) {
                        set_recorded_txs_id(txsId);
                    }
                } catch (e) {
                    console.warn('record_transaction returned no txs_id');
                }
                {
                    const amtNum = Number(amount);
                    if (!Number.isNaN(amtNum) && amtNum >= LARGE_AMOUNT) {
                        notifyAdminC2cRequest({
                            source: 'wallet_large_amount_squads',
                            flow: 'mint_large_amount',
                            large_amount_threshold: LARGE_AMOUNT,
                            wallet_address: connectedPublicKey,
                            txs_type: 'mint',
                            method: selectedToken,
                            amount,
                            transaction_signature: signature,
                            txs_id: data?.txs_id ?? data?.id ?? null,
                        });
                    }
                }
                showNotification('success', 'Squads proposal creating...', 20000)
                await triggerMintTransferToAddress(signature, fromPublicKeyStr, toAddress, amount, selectedToken);
                console.log("trigger Mint Transfer To Address Complete")


            } else if (transactionType === 'redeem') {
                const payload = {
                    txs_type: transactionType,
                    method: selectedToken,
                    from_token_amount: amount,
                    from_address: connectedPublicKey,
                    transaction_signature: signature,
                    referral_code: ''
                };
                const data = await record_transaction(payload);
                try {
                    const txsId = data?.txs_id ?? data?.id ?? null;
                    if (txsId !== null && set_recorded_txs_id) {
                        set_recorded_txs_id(txsId);
                    }
                } catch (e) {
                    console.warn('record_transaction returned no txs_id');
                }
                {
                    const amtNum = Number(amount);
                    if (!Number.isNaN(amtNum) && amtNum >= LARGE_AMOUNT) {
                        notifyAdminC2cRequest({
                            source: 'wallet_large_amount_squads',
                            flow: 'redeem_large_amount',
                            large_amount_threshold: LARGE_AMOUNT,
                            wallet_address: connectedPublicKey,
                            txs_type: 'redeem',
                            method: selectedToken,
                            amount,
                            transaction_signature: signature,
                            txs_id: data?.txs_id ?? data?.id ?? null,
                        });
                    }
                }
                showNotification('success', 'Squads proposal creating...',20000)
                await triggerRedeemTransferToAddress(signature, fromPublicKeyStr, toAddress, amount, selectedToken);
                console.log("trigger Redeem Transfer To Address Complete")

            }

        } catch (err) {
            console.error(`Error transferring token on Solana:`, err);
            if (err?.code === 4001) {
                showNotification('error', "User rejected the transaction.");
            } else {
                if (err && err.message) {
                    showNotification('error', `Transaction failed: ${err.message}`);
                } else {
                    console.log("error! ", err);
                    showNotification('error', 'Transaction failed, please try again');
                }
            }
        }
    };

    // 金额大于11000， 到后台trigger squads
    const triggerMintTransferToAddress = async (signature, fromAddr, toAddr, amt, tokenType) => {
        await sleep(10000);
        const requestBody = {
            "transaction_hash": String(signature),
            "from_address": String(fromAddr),
            "to_address": String(toAddr),
            "amount": String(amt),
            "token-type": String(tokenType)
        };
        fetch("https://usdi-api-256611876551.europe-west1.run.app/trigger-mint-transfer-to-address", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(requestBody)
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`Server responded with status: ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                console.log("API response:", data);
                showNotification('success', 'Squads proposal successfully created.')

            })
            .catch((err) => {
                console.error("Error sending to server:", err);
                showNotification('error', 'Squads proposal creation failed, please contact support.');
            });
    };

    // 金额大于11000， 到后台trigger squads
    async function triggerRedeemTransferToAddress(signature, fromAddr, toAddr, amt, tokenType) {
        // console.log("Manual redeem triggered. Sending body:", signature, fromAddr, toAddr, amt, tokenType);
        await sleep2(10000);
        const requestBody = {
            transaction_hash: String(signature),
            from_address: String(fromAddr),
            to_address: String(toAddr),
            amount: String(amt),
            token_type: String(tokenType)
        };
        fetch("https://usdi-api-256611876551.europe-west1.run.app/trigger-redeem-transfer-to-address", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(requestBody)
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`Server responded with status: ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                console.log("Redeem API response:", data);
                showNotification('success', 'Squads proposal successfully created.')
            })
            .catch((err) => {
                console.error("Error calling redeem API:", err);
                showNotification('error', 'Squads proposal creation failed, please contact support.');
            });
    }

    // DISCONNECT
    const disconnectWallet = async () => {
        try {
            if (okxSolanaProvider && okxSolanaProvider.disconnect) {
                okxSolanaProvider.disconnect();
            }
            if (coinbaseSolanaProvider) {
                await window.coinbaseSolana.disconnect();
            }
            if (walletConnectProvider && walletConnectProvider.disconnect) {
                await walletConnectProvider.disconnect();
            }
            if (phantomSolanaProvider && phantomSolanaProvider.disconnect) {
                await phantomSolanaProvider.disconnect();
            }
            if (metaMaskSolanaProvider && metaMaskSolanaProvider.disconnect) {
                await metaMaskSolanaProvider.disconnect();
            }
            setConnectedPublicKey(null);
            setWalletAddress("Connect Wallet");

            setOkxSolanaProvider(null);
            setCoinbaseSolanaProvider(null);
            setWalletConnectProvider(null);
            setPhantomSolanaProvider(null);
            setMetaMaskSolanaProvider(null);
            setShowPanel(false);
            setConnectedWalletType(null);
            localStorage.removeItem('lastConnectedWallet');
            localStorage.removeItem('walletAddress');
            localStorage.removeItem('userClass');
            localStorage.removeItem('referralCode');
            if (onWalletConnected) {
                onWalletConnected(null, 0, 0, 0);
            }
            showNotification('success', 'Your wallet has been successfully disconnected.')
            // 用来删除 别的page 的state：
            if (onClearAccountData) {
                onClearAccountData();
            }
            if (onClearTransactions) {
                onClearTransactions();
            }
        } catch (err) {
            console.error("Error disconnecting wallet:", err);
        }
    };


    return (
        <div
            className={
                isAdminHeader
                    ? `${styles.outerContainer} ${styles.outerContainer2}`
                    : styles.outerContainer
            }
            onClick={handleOutsideClick}
        >
            {!isAdminHeader && (
                <img
                    className={styles.vectorIcon}
                    src={logo_svg}
                    style={{width: '110px', height: '34px'}}
                    alt="KiraAI"
                />
            )}

            {/*for admin page onClick only */}
            {isAdminHeader && (
                <ConnectWalletHeaderAdminNavBar/>
            )}
            {notification.message ? (
                <div className={styles.transactionErrorBoxWapper}>
                    <div className={styles.transactionErrorBox}>
                        <div className={styles.transactionErrorContent}>
                            <img
                                src={
                                    notification?.status === 'error'
                                        ? rejectImg
                                        : notification?.status === 'warning'
                                            ? warningImg
                                            : successImg
                                }
                                alt={notification.status || 'status'}
                                className={styles.rejectIcon}
                            />
                            <span
                                className={styles.errorMessage}
                                dangerouslySetInnerHTML={{__html: notification.message}}
                            />
                        </div>
                        <img
                            className={styles.cancelBtn}
                            src={cancle_icon}
                            alt="x"
                            onClick={() => showNotification(null, null)}
                        />
                    </div>
                </div>
            ) : (
                <div className={
                    isAdminHeader
                        ? `${styles.container} ${styles.container2}`
                        : isKiraAIPage
                            ? `${styles.container} ${styles.container3}`
                            : styles.container
                }>
                    {isSideMenuOpen ? (
                        <SideMenu
                            isOpen={isSideMenuOpen}
                            selectedMenuItem={selectedMenuItem}
                            onMenuItemClick={handleMenuItemClick}
                            onOverlayClick={handleOutsideClickSideMenu}
                            stopPropagation={(e) => e.stopPropagation()}
                        />
                    ) : (
                        <div
                            className={styles.userIconContainer}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div
                                className={
                                    `${styles.userIcon} ` +
                                    (
                                        walletAddress === "Connect Wallet" || walletAddress === "Create Wallet"
                                            ? styles.userIconNoHover
                                            : styles.userIconRedHover
                                    ) +
                                    (isAdminHeader ? ` ${styles.userIcon2}` : "")
                                }
                                onClick={handleConnectWalletClick}
                                style={{
                                    background:
                                        walletAddress === "Connect Wallet" || walletAddress === "Create Wallet"
                                            ? "white"
                                            : "#32353D",
                                    color:
                                        walletAddress === "Connect Wallet" || walletAddress === "Create Wallet"
                                            ? "black"
                                            : "white",
                                    borderRadius: "10px",
                                    width: "151px"
                                }}
                            >
                                {walletAddress === "Connect Wallet" || walletAddress === "Create Wallet"
                                    ? ""
                                    : connectedWalletType === "okx"
                                        ? (
                                            <img
                                                style={{
                                                    borderRadius: '50%',
                                                    width: '18px',
                                                    height: '18px',
                                                    marginRight: '8px',
                                                    marginLeft: '0px'
                                                }}
                                                src={okx_icon}
                                                alt="OKX"
                                            />
                                        ) : connectedWalletType === "coinbase"
                                            ? (
                                                <img
                                                    style={{
                                                        borderRadius: '50%',
                                                        width: '18px',
                                                        height: '18px',
                                                        marginRight: '8px',
                                                        marginLeft: '0px'
                                                    }}
                                                    src={coinbase_icon}
                                                    alt="Coinbase"
                                                />
                                            ) : connectedWalletType === "walletconnect"
                                                ? (
                                                    <img
                                                        style={{
                                                            borderRadius: '50%',
                                                            width: '18px',
                                                            height: '18px',
                                                            marginRight: '8px',
                                                            marginLeft: '0px'
                                                        }}
                                                        src={walletconnect_icon}
                                                        alt="WalletConnect"
                                                    />
                                                ) : connectedWalletType === "phantom"
                                                    ? (
                                                        <img
                                                            style={{
                                                                borderRadius: '50%',
                                                                width: '18px',
                                                                height: '18px',
                                                                marginRight: '8px',
                                                                marginLeft: '0px'
                                                            }}
                                                            src={Phantom_icon}
                                                            alt="Phantom"
                                                        />
                                                    ) : connectedWalletType === "metamask"
                                                        ? (
                                                            <img
                                                                style={{
                                                                    borderRadius: '50%',
                                                                    width: '18px',
                                                                    height: '18px',
                                                                    marginRight: '8px',
                                                                    marginLeft: '0px',
                                                                    background:'transparent'
                                                                }}
                                                                src={metamask_icon}
                                                                alt="MetaMask"
                                                            />
                                                        ) : null
                                }
                                {walletAddress}
                                {walletAddress === "Connect Wallet" || walletAddress === "Create Wallet" ? '' : (
                                    <img
                                        style={{
                                            borderRadius: '50%',
                                            width: '20px',
                                            height: '20px',
                                            marginRight: '0px',
                                            marginLeft: '8px',
                                            background: 'none',
                                            marginTop: '3px',
                                        }}
                                        className={styles.downArrow}
                                        src={menuDropDownImg}
                                        alt="arrow"
                                    />
                                )}
                            </div>

                            <img
                                className={
                                    isAdminHeader
                                        ? `${styles.menu_mobile_icon} ${styles.menu_mobile_icon2}`
                                        : styles.menu_mobile_icon
                                }
                                src={menu_icon}
                                style={{width: '22px', height: '22px'}}
                                alt="Menu"
                                onClick={handleMenuIconClick}
                            />

                            {showPanel && (
                                <div
                                    className={styles.overlay}
                                    onClick={handleOutsideClick}
                                ></div>
                            )}

                            <div
                                className={
                                    `${styles.sidePanel} ` +
                                    (showPanel
                                        ? (connectedPublicKey ? styles.openConnected : styles.openNotConnected)
                                        : '')
                                }
                                style={{"width": "352px"}}
                                onClick={stopPropagation}
                            >
                                <div className={styles.connectHeader}>
                                    <h3>Connect</h3>
                                    <div
                                        className={styles.closeBtn}
                                        onClick={closePanel}
                                        aria-label="Close"
                                    >
                                        ×
                                    </div>
                                </div>

                                <div className={styles.lineWrapper}>
                                    <div className={styles.dividerLineFull}></div>
                                </div>

                                <div style={{background: "#1c1c1c"}}>
                                    {/* Phantom */}
                                    <div className={styles.connectOption} onClick={handlePhantomWalletSolana}>
                                        <img className={styles.walletIcon}
                                             src={isMobile ? Phantom_icon_mobile : Phantom_icon}
                                             alt="Phantom"/>
                                        <div className={styles.walletType}><p>Phantom Wallet</p>
                                            {isPhantomDetected && <div className={styles.detect}>detected</div>}
                                        </div>
                                    </div>

                                    {/* MetaMask */}
                                    <div className={styles.connectOption} onClick={handleMetaMaskSolana}>
                                        <img className={styles.walletIcon}
                                             src={isMobile ? metamask_icon_mobile : metamask_icon}
                                             alt="MetaMask"/>
                                        <div className={styles.walletType}><p>MetaMask</p>
                                            {isMetaMaskDetected && <div className={styles.detect}>detected</div>}
                                        </div>
                                    </div>

                                    {/* OKX */}
                                    <div className={styles.connectOption} onClick={handleOKXWalletSolana}>
                                        <img className={styles.walletIcon} src={isMobile ? okx_icon_mobile : okx_icon}
                                             alt="OKX"/>
                                        <div className={styles.walletType}><p>OKX Wallet</p>
                                            {isOkxDetected && <div className={styles.detect}>detected</div>}
                                        </div>
                                    </div>

                                    {/* Coinbase */}
                                    <div className={styles.connectOption} onClick={handleCoinbaseWalletSolana}>
                                        <img className={styles.walletIcon}
                                             src={isMobile ? coinbase_icon_mobile : coinbase_icon}
                                             alt="Coinbase"/>
                                        <div className={styles.walletType}><p>Coinbase Wallet</p>
                                            {isCoinbaseDetected && <div className={styles.detect}>detected</div>}
                                        </div>
                                    </div>

                                    {/* WalletConnect：此处不需要检测 */}
                                    <div className={styles.connectOption} onClick={handleWalletConnectSolana}>
                                        <img className={styles.walletIcon}
                                             src={isMobile ? walletconnect_icon_mobile : walletconnect_icon}
                                             alt="WalletConnect"/>
                                        <p>WalletConnect</p>
                                    </div>
                                    {connectedPublicKey && (
                                        <div className={styles.lineWrapper}>
                                            <div className={styles.dividerLineFullLower}></div>
                                        </div>
                                    )}

                                    {connectedPublicKey && (
                                        <div
                                            className={styles.connectOption}
                                            onClick={disconnectWallet}
                                            style={{paddingTop: "10px", paddingBottom: '10px'}}
                                        >
                                            <img style={{width: "30px", height: "30px"}}
                                                 className={styles.walletIcon}
                                                 src={disconnectImg} alt="disconnect"/>
                                            <p style={{color: 'red', lineHeight: "30px"}}>Disconnect</p>
                                        </div>
                                    )}

                                    <div className={styles.lineWrapper}>
                                        <div className={styles.dividerLine}></div>
                                        <div className={styles.or}>Or</div>
                                        <div className={styles.dividerLine}></div>
                                    </div>

                                    {/* Email */}
                                    {localStorage.getItem("userEmail") ? (
                                        <div className={styles.connectOption}>
                                            <img
                                                style={{background: '#1C1C1C', marginRight: '17px', width: '30px'}}
                                                src={email_svg}
                                                alt="email"
                                            />
                                            <div className={styles.emailType} onClick={handleLogoutWithEmail}>
                                                <p>{localStorage.getItem("userEmail")}</p>
                                                <img
                                                    style={{background: '#1C1C1C', marginRight: '17px'}}
                                                    src={emailLogoutImg}
                                                    alt="email"
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            className={styles.connectOption}
                                            onClick={handleLoginWithEmail}
                                        >
                                            <img
                                                style={{background: '#1C1C1C', marginRight: '17px', width: '30px'}}
                                                src={email_svg}
                                                alt="email"
                                            />
                                            <p>Log in with Email</p>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ConnectWalletHeader;
